import type { SortDirection, SortDirectionReturn } from '@/types'

export const splitSortOption = <T>(sortOption: string): SortDirectionReturn<T> => {
  const splitOption = sortOption.split('-')
  const option = splitOption[0] as keyof T
  const direction = splitOption[1] as SortDirection

  return { option, direction }
}
